import * as React from 'react';
/**
 *
 * Original name: sound off
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=2916%3A1085
 *
 */
export const SoundOffLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m14.5 13.142-1.5 1.5v2.77l-1.647-1.123-1.08 1.08L14.5 20.25v-7.108Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m5.44 20.082-1-1 2.597-2.598C4.995 16.34 4 15.195 4 13c0-2.355 1.145-3.5 3.5-3.5H9l5.5-3.75v3.27l4.081-4.08 1 1L5.44 20.081ZM13 10.52 8.52 15H7.5c-.957 0-1.378-.234-1.573-.428-.194-.195-.427-.616-.427-1.573s.233-1.378.427-1.572C6.122 11.233 6.543 11 7.5 11h1.963L13 8.588v1.933Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
